import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef, useState, useRef } from 'react';
import { useIsomorphicLayoutEffect } from '../../hooks/useIsomorphicLayoutEffect.js';
import { jsx } from '@emotion/react';

const AutosizeInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    className,
    value,
    placeholder,
    ...inputProps
  } = _ref;
  const [inputWidth, setInputWidth] = useState(1);
  const sizerRef = useRef(null);
  useIsomorphicLayoutEffect(() => {
    const newInputWidth = (sizerRef.current?.scrollWidth || 0) + 2;
    if (inputWidth !== newInputWidth) {
      setInputWidth(newInputWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, placeholder]);
  return jsx("div", {
    className: className,
    ref: ref,
    style: {
      display: "inline-block"
    }
  }, jsx("input", _extends({
    style: {
      boxSizing: "content-box",
      width: `${inputWidth}px`
    },
    value: value,
    placeholder: placeholder
  }, inputProps)), jsx("div", {
    ref: sizerRef,
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      visibility: "hidden",
      height: 0,
      overflow: "scroll",
      whiteSpace: "pre"
    }
  }, !value || value === "" ? placeholder : value));
});

export { AutosizeInput };
